export default __webpack_public_path__ + "static/media/feedback.0302f52f.png";